module.exports = __webpack_public_path__ + "img/06.25dca0b4.jpg";